import { render, staticRenderFns } from "./InputAnggota.vue?vue&type=template&id=45a4786e&scoped=true&"
import script from "./InputAnggota.vue?vue&type=script&lang=js&"
export * from "./InputAnggota.vue?vue&type=script&lang=js&"
import style0 from "./InputAnggota.vue?vue&type=style&index=0&id=45a4786e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4786e",
  null
  
)

export default component.exports